import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/hooks/useLenis";

export const PageShell = ({ children }) => {
  useLenis();
  return (
    <div className="dark bg-[#050505] text-white noise-overlay relative min-h-screen">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
